import React, { useState } from "react";
import "./StateSuburb.css";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap/Pagination";

const StateSuburb = ({ bgwhite, name, citylist, cityIdhandler }) => {
  const pageSize = 100; // Number of items per page
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total number of pages
  const totalPages = Math.ceil(citylist?.[0]?.length / pageSize);

  // Function to get current page data
  const getCurrentPageData = () => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return citylist?.[0]?.slice(startIndex, endIndex);
  };

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Generate pagination items with ellipses
  const renderPaginationItems = () => {
    const items = [];

    // Add first page and ellipsis if needed
    if (currentPage > 3) {
      items.push(
        <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
          1
        </Pagination.Item>
      );
      items.push(<Pagination.Ellipsis key="start-ellipsis" />);
    }

    // Add pages around current page
    for (let number = Math.max(1, currentPage - 2); number <= Math.min(totalPages, currentPage + 2); number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    // Add ellipsis and last page if needed
    if (currentPage < totalPages - 2) {
      items.push(<Pagination.Ellipsis key="end-ellipsis" />);
      items.push(
        <Pagination.Item key={totalPages} onClick={() => handlePageChange(totalPages)}>
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <>
      <section className={`keyzi_stateSuburbList--wrapper ${bgwhite}`}>
        <div className="container">
          <div className="keyzi_stateSuburbList--inner">
            <h5>{name}</h5>
            <div className="row">
              <div className="city-list">
                <ul className="list location-list">
                  {getCurrentPageData()?.map((item, index) => (
                    <li key={index}>
                      <Link
                        onClick={() => cityIdhandler(item?.id)}
                        to={`/xcsfvt/driving-instructors/${item?.state_code.trim()}/${item?.place_name
                          .trim()
                          .replace(/\s+/g, "-")}`}
                      >
                        {item?.place_name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            {/* Bootstrap Pagination */}
            <Pagination>
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              />
              {renderPaginationItems()}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          </div>
        </div>
      </section>
    </>
  );
};

export default StateSuburb;
